import { Pipe, PipeTransform } from '@angular/core';

/**
 * Minimal, safe formatter for the assistant's reply text -- LLM output is plain text with
 * markdown-style **bold** and newline-separated list items, which rendered unescaped/unstyled
 * runs everything together in one unreadable block. Escapes HTML first (untrusted input), then
 * converts just the 2 markers the prompt actually produces. Bound via [innerHTML], which Angular
 * sanitizes automatically -- no bypassSecurityTrust needed. Ported from Ecommerce Front End's
 * chat-format.pipe.ts - same AI Agents reply contract, same 2 markers.
 */
@Pipe({ name: 'chatFormat', standalone: true })
export class ChatFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return escaped.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>');
  }
}
